import { useTenantConfiguration } from '@/hooks/useTenantConfiguration';
import HistoryLayout from '@/routes/account/layout/HistoryLayout';
import type { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface TravelPassesProps {}

const TravelPasses: FC<TravelPassesProps> = () => {
  const tenantConfiguration = useTenantConfiguration();

  // navigate back to account details if tenant doesn't show travel passes
  if (!tenantConfiguration?.showAccountMenuTravelPass) {
    return <Navigate to="/account/details" replace />;
  }

  return (
    <HistoryLayout bookingType="travelPasses">
      <Outlet />
    </HistoryLayout>
  );
};

export default TravelPasses;
